let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kel8g")).then(() => parcelRequire('jyFo7'));